"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-ten/sections/serviceSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSection46sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/icons/service-12.svg" | "/Templates/Doccure/img/icons/service-13.svg" | "/Templates/Doccure/img/icons/service-14.svg" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/service/service-10.jpg" | "/Templates/Doccure/img/service/service-11.jpg" | "/Templates/Doccure/img/service/service-12.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "IVF (In Vitro Fertilization)" | "Egg Freezing" | "IUI (Intrauterine Insemination)" */
    h30Text: ReactNode;
    /** Detected variants: "A highly effective treatment where eggs and sperm are combined in a lab to achieve fertilization" | "A modern preservation option allowing women to freeze healthy eggs for future family planning." | "A simple procedure that places prepared sperm into the uterus to improve conception chances." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-4 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "services-item-ten flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "service-img" */
    div0ClassName2?: string;
    /** Detected variants: "service-icon" */
    div0ClassName3?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "service" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "service-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "" */
    div0div1p0Expr1?: ReactNode;
};
export type HomeTenServiceSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSection46sItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0Div0ClassName?: string;
    /** Default: "Services" */
    sectionDiv0Div0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Specialized Fertility Solutions" */
    sectionDiv0Div0Div0Div0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "all_routes.speciality" */
    sectionDiv0Div0Div0Div1Div0Link0LinkHref?: string;
    /** Default: "View All" */
    sectionDiv0Div0Div0Div1Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div1Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div1ClassName?: string;
    serviceSection46s: ServiceSection46sItem[];
    serviceSection46sItemWrapper?: (item: ServiceSection46sItem, content: ReactNode) => ReactNode;
    serviceSection46sRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSection46sImageVisible?: boolean;
    serviceSection46sImageRenderer?: (item: ServiceSection46sItem, defaultNode: ReactNode) => ReactNode;
    serviceSection46sH3Visible?: boolean;
    serviceSection46sH3Renderer?: (item: ServiceSection46sItem, defaultNode: ReactNode) => ReactNode;
    serviceSection46sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSection46sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    serviceSection46sH3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSection46sItem) => Partial<ComponentProps<"h3">>);
};

const HomeTenServiceSectionGenerated: FC<HomeTenServiceSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Div0DivText = "Services",
    sectionDiv0Div0Div0Div0Div0H20H2Text = "Specialized Fertility Solutions",
    sectionDiv0Div0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div1Div0Link0LinkHref = "all_routes.speciality",
    sectionDiv0Div0Div0Div1Div0Link0LinkText = "View All",
    sectionDiv0Div0Div0Div1Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div1Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div1Div0Link0LinkProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    sectionDiv0Div0Div0ClassName,
    sectionDiv0Div1ClassName,
    serviceSection46s,
    serviceSection46sItemWrapper,
    serviceSection46sRenderer,
    serviceSection46sImageVisible,
    serviceSection46sImageRenderer,
    serviceSection46sH3Visible,
    serviceSection46sH3Renderer,
    serviceSection46sImageProps,
    serviceSection46sH3Props,
}) => {
    return (
        <section className="services-section-ten section">
            <div className="container">
                <div className="section-header section-header-ten">
                    <div className={sectionDiv0Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-md-9">
                            <div>
                                <div className="section-sub-title">
                                    <span className="sec-circle" aria-hidden="true" />
                                    {sectionDiv0Div0Div0Div0Div0Div0DivText}
                                </div>
                                {renderNode(sectionDiv0Div0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div0Div0Div0H20H2Props ?? {})}>{sectionDiv0Div0Div0Div0Div0H20H2Text}</h2>
                                ))}
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="text-md-end">
                                {renderNode(sectionDiv0Div0Div0Div1Div0Link0LinkVisible, sectionDiv0Div0Div0Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div1Div0Link0LinkHref} className="btn btn-secondary" {...(sectionDiv0Div0Div0Div1Div0Link0LinkProps ?? {})}>
                                        {sectionDiv0Div0Div0Div1Div0Link0LinkText}
                                        <i className="isax isax-arrow-right-1 ms-2" />
                                    </SmartLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4 justify-content-center"}>
                    {renderCollectionNode(
                        serviceSection46s,
                        (item: ServiceSection46sItem) => (
                            <div className={item.className ?? "col-xl-4 col-md-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "services-item-ten flex-fill wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "service-img"}>
                                        {renderItemNode(serviceSection46sImageVisible, serviceSection46sImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "service"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid"} {...(typeof serviceSection46sImageProps === "function" ? serviceSection46sImageProps(item) : (serviceSection46sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <div className={item.div0ClassName3 ?? "service-icon"}>
                                            {renderItemNode(serviceSection46sImageVisible, serviceSection46sImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof serviceSection46sImageProps === "function" ? serviceSection46sImageProps(item) : (serviceSection46sImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "service-content"}>
                                        {renderItemNode(serviceSection46sH3Visible, serviceSection46sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof serviceSection46sH3Props === "function" ? serviceSection46sH3Props(item) : (serviceSection46sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p>
                                            {item.p0Text}
                                            {" "}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ),
                        serviceSection46sItemWrapper,
                        serviceSection46sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeTenServiceSectionGenerated;
